import React, {Component} from "react";
import PropTypes from "prop-types";

import {remove, cloneDeep} from "lodash";

import {
    Row,
    Col,
    Button,
    Modal,
    ModalBody,
    Spinner,
    Alert,
    Input,
} from "reactstrap";
//classes
import WbSession from "classes/Session.jsx";
// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

class ImageUploader extends Component {
    static contextType = WbSession;
    
    debug = false;
    
    state = {
        newImages: [],
        previewPhoto: null,
        // Errors
        error: false,
        errorMsg: ""
    }
    
    componentDidMount() {
        const { readonly } = this.props;
        if( readonly ){
            return;
        }
    }
    
    handleSelectFile = async ( file ) => {
        const { newImages } = this.state;
        
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            if(this.debug) console.log("File selected: ",file);
            if( this.debug ) console.log("Image loaded: ",reader.result);
            let newImageId = Math.floor((1 + Math.random()) * 0x1000);
            newImages.push({src:reader.result, id:newImageId});
            
            this.uploadPhotoToServer( reader.result, newImageId, file.name );
            
            this.setState({newImages:newImages});
        };
    };
    
    uploadPhotoToServer = async ( imageData, imageId, imageName ) => {
        const response = await this.context.uploadFile( imageData, imageName );
        
        if(this.debug) console.log("Image upload response",response);
        if( typeof response.code !== "undefined" && 'success' !== response.code ){
            console.warn('Failed to upload image.', response);
            let errorMsg = (response.message || "Failed to upload image. Please try again later.");
            this.setState( {
                error: true,
                errorMsg: errorMsg
            } );
        } else {
            this.addToExistingPhotos( response.data.id, response.data.url, imageId );
        }
    };
    
    removeExistingPhoto = ( image_id ) => {
        const { value, onChange } = this.props;
        
        // Decode JSON for value
        let decodedValue = [];
        try{
            if( '' != value ){
                decodedValue = JSON.parse(value);
            }
        } catch(e) {
            console.warn("Failed to decode json value (ex images)", e);
        }
        if( typeof decodedValue.length == "undefined" ){
            decodedValue = [];
        }
        
        // //loop through, delete by array value (key is URL, value is ID)
        // let newValue = {};
        // Object.keys(decodedValue).forEach((url) => {
        //     const id = decodedValue[url] ?? 0;
        //     if( id != image_id ){
        //         newValue[url] = id;
        //     }
        // });
        
        //loop through, delete by array key (key is ID)
        let newValue = cloneDeep( decodedValue );
        remove(newValue, (row)=>{
            return row.id==image_id;
        });
        
        onChange( JSON.stringify(newValue) );
    };
    
    addToExistingPhotos = ( image_id, image_url, tmp_id ) => {
        const { value, onChange } = this.props;
        
        // Decode JSON for value
        let decodedValue = [];
        try{
            if( '' != value ){
                decodedValue = JSON.parse(value);
            }
        } catch(e) {
            console.warn("Failed to decode json value (ex images)", e);
        }
        if( typeof decodedValue.length == "undefined" ){
            decodedValue = [];
        }
        
        //set a new key/value
        decodedValue.push( {
            id: image_id,
            url: image_url,
            caption: ''
        });
        
        // Delete temporary image
        if( typeof tmp_id != "undefined" && tmp_id ){
            this.removeNewPhoto( tmp_id );
        }
        
        onChange( JSON.stringify(decodedValue) );
    };
    
    captionExistingPhoto = ( image_id, caption ) => {
        const { value, onChange } = this.props;
        
        // Decode JSON for value
        let decodedValue = [];
        try{
            if( '' != value ){
                decodedValue = JSON.parse(value);
            }
        } catch(e) {
            console.warn("Failed to decode json value (ex images)", e);
        }
        if( typeof decodedValue.length == "undefined" ){
            decodedValue = [];
        }
        
        //loop through, delete by array value (key is URL, value is ID)
        let newValue = [];
        decodedValue.forEach((atts) => {
            let data = atts;
            if( data.id == image_id ){
                data.caption = caption;
            }
            newValue.push( data );
        });
        
        onChange( JSON.stringify(newValue) );
    };
    
    removeNewPhoto = ( index ) => {
        const { newImages } = this.state;
        
        remove(newImages, (row)=>{
            return row.id==index;
        });
        
        this.setState({newImages:newImages});
    };
    
    render(){
        const { newImages, previewPhoto, error, errorMsg } = this.state;
        
        const {
            fldId,
            value,
            readonly,
            helperText,
            onChange,
            className,
        } = this.props;
        
        if(this.debug) console.log("Existing images: ",value);
        let exImages = [];
        try{
            if( '' != value ){
                exImages = JSON.parse(value);
            }
        } catch(e) {
            console.warn("Failed to decode json value (ex images)", e);
        }
        if( typeof exImages.length == "undefined" ){
            exImages = [];
        }
        if(this.debug) console.log("Existing images: ",exImages);
        
        return (
            <>
                <div className="wb_image_selector" id={"iamges_"+fldId}>
                    {(!readonly) ? (
                        <div className="custom-file">
                            <input
                                className="custom-file-input"
                                id="imageUploader"
                                multiple="multiple"
                                type="file"
                                accept="image/*"
                                onChange={(e)=>{
                                    const files = Array.from(e.target.files);
                                    
                                    files.map((file)=>{
                                        this.handleSelectFile( file );
                                    })
                                }}
                            />
                            <label
                                className="custom-file-label"
                                htmlFor="imageUploader"
                            />
                        </div>
                    ) : (null)}
                    {/* display image previews */}
                    {(exImages.length || newImages.length) ? (
                        <>
                        <h4 className="mt-sm-3">Existing Photos</h4>
                        <Row
                            className="list-group-lg"
                            flush="true"
                        >
                            {exImages.map( (img) => (
                                <Col key={img.id} xs="6" lg="4" xl="3" className="px-0">
                                    <div className="photoPreview-wrapper">
                                        <div className="photoPreview">
                                            <img
                                                className="photoPreview-img rounded"
                                                src={img.url}
                                                onClick={(e)=>{
                                                    this.setState({previewPhoto:e.target.src});
                                                }}
                                            />
                                            <Input
                                                type="text"
                                                value={img.caption}
                                                placeholder='Enter caption...'
                                                onChange={(e)=>{
                                                    this.captionExistingPhoto( img.id, e.target.value );
                                                }}
                                            />
                                        </div>
                                        <div
                                            className="removePhoto"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.removeExistingPhoto( img.id );
                                            }}
                                        >
                                            <FontAwesomeIcon className="menuIcon" icon={faTimes} />
                                        </div>
                                    </div>
                                </Col>
                            ) )}
                            {newImages.map( (img, idx) => (
                                <Col key={img.id} xs="6" lg="4" xl="3" className="px-0">
                                    <div className="photoPreview-wrapper">
                                        <div className="photoPreview previewLoading">
                                            <img
                                                className="photoPreview-img rounded"
                                                src={img.src}
                                                onClick={(e)=>{
                                                    this.setState({previewPhoto:e.target.src});
                                                }}
                                            />
                                            <Spinner color="primary" className="previewLoading-spinner" />
                                        </div>
                                        {/*<div
                                            className="removePhoto"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.removeNewPhoto( idx );
                                            }}
                                        >
                                            <FontAwesomeIcon className="menuIcon" icon={faTimes} />
                                        </div>*/}
                                    </div>
                                </Col>
                            ) )}
                        </Row>
                        </>
                    ) : (null)}
                    {(error) ? (
                        <Alert color="danger">Error: {errorMsg}</Alert>
                    ) : (null)}
                </div>
                <Modal size="xl" toggle={()=>this.setState({previewPhoto:null})} isOpen={null!==previewPhoto}>
                    <div className=" modal-header">
                        <h5 className=" modal-title" id="previewModalLabel">
                            Take Photo
                        </h5>
                        <button
                            aria-label="Close"
                            className=" close"
                            type="button"
                            onClick={() => this.setState({previewPhoto:null})}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <ModalBody className="previewModal">
                        <img
                            className="photoPreview-img"
                            src={previewPhoto}
                        />
                    </ModalBody>
                </Modal>
            </>
        );
    }
}

ImageUploader.propTypes = {
    fldId: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    readonly: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
};

ImageUploader.defaultProps = {
    fldId: null,
    value: null,
    readonly: null,
    error: false,
    helperText: '',
    onChange: (newVal) => {console.log('ImageUploader value updated',newVal)},
    className: "",
}

export default ImageUploader;
